import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/dashboard/Home";
import GenericPage from "./pages/dashboard/GenericPage";
import OverviewStatistics from "./pages/statistics/OverviewStatistics";
import ProgressReport from "./pages/statistics/ProgressReport";
import ProjectImplementation from "./pages/statistics/ProjectImplementation";
import ProjectStatistics from "./pages/statistics/ProjectStatistics";
import OngoingProjectDetail from "./pages/projects/OngoingProjectDetail";
import CompletedProjectDetail from "./pages/projects/CompletedProjectDetail";
import AddProductTypeI from "./pages/projects/AddProductTypeI";
import AddProductTypeII from "./pages/projects/AddProductTypeII";
import AddProductTypeIII from "./pages/projects/AddProductTypeIII";
import AddProductTypeIIIJournal from "./pages/projects/AddProductTypeIIIJournal";
import AddProductTypeIIIBook from "./pages/projects/AddProductTypeIIIBook";
import AddDelegationMember from "./pages/projects/AddDelegationMember";
import AddCouncilMember from "./pages/management/AddCouncilMember";
import CouncilMembers from "./pages/management/CouncilMembers";
import CompletedProjects from "./pages/projects/CompletedProjects";
import IncompleteProjects from "./pages/projects/IncompleteProjects";
import OngoingProjects from "./pages/projects/OngoingProjects";
import EditCompletedProject from "./pages/projects/EditCompletedProject";
import EditOngoingProject from "./pages/projects/EditOngoingProject";
import TopicApproval from "./pages/projects/TopicApproval";
import CooperationOrganizations from "./pages/cooperation/CooperationOrganizations";
import IncomingDelegations from "./pages/cooperation/IncomingDelegations";
import DelegationDetail from "./pages/cooperation/DelegationDetail";
import OutgoingDelegations from "./pages/cooperation/OutgoingDelegations";
import OutgoingDelegationDetail from "./pages/cooperation/OutgoingDelegationDetail";
import ForeignStaff from "./pages/cooperation/ForeignStaff";
import ConferencesWorkshops from "./pages/cooperation/ConferencesWorkshops";
import IncomingDocuments from "./pages/documents/IncomingDocuments";
import IncomingDocumentsList from "./pages/documents/IncomingDocumentsList";
import AddNewDocument from "./pages/documents/AddNewDocument";
import IncomingDocumentsUnprocessed from "./pages/documents/IncomingDocumentsUnprocessed";
import IncomingDocumentsAssigned from "./pages/documents/IncomingDocumentsAssigned";
import IncomingDocumentsReading from "./pages/documents/IncomingDocumentsReading";
import OutgoingDocumentsUnprocessed from "./pages/documents/OutgoingDocumentsUnprocessed";
import OutgoingDocumentsAssigned from "./pages/documents/OutgoingDocumentsAssigned";
import OutgoingDocumentsReading from "./pages/documents/OutgoingDocumentsReading";
import LegalDocuments from "./pages/documents/LegalDocuments";
import DocumentGroups from "./pages/documents/DocumentGroups";
import AddNewDocumentGroup from "./pages/documents/AddNewDocumentGroup";
import ScientificArticles from "./pages/research/ScientificArticles";
import AddNewArticle from "./pages/research/AddNewArticle";
import ArticleDetail from "./pages/research/ArticleDetail";
import EditArticle from "./pages/research/EditArticle";
import ExperienceInitiatives from "./pages/research/ExperienceInitiatives";
import ExperienceInitiativeDetail from "./pages/research/ExperienceInitiativeDetail";
import AddNewInitiative from "./pages/research/AddNewInitiative";
import EditInitiative from "./pages/research/EditInitiative";
import IntellectualProperty from "./pages/research/IntellectualProperty";
import AddNewIntellectualProperty from "./pages/research/AddNewIntellectualProperty";
import Contracts from "./pages/management/Contracts";
import ContractDetail from "./pages/management/ContractDetail";
import AddNewContract from "./pages/management/AddNewContract";
import EditContract from "./pages/management/EditContract";
import Councils from "./pages/management/Councils";
import CouncilDetail from "./pages/management/CouncilDetail";
import AddNewCouncil from "./pages/management/AddNewCouncil";
import EditCouncil from "./pages/management/EditCouncil";
import Experts from "./pages/management/Experts";
import EditExpert from "./pages/management/EditExpert";
import ScientificCV from "./pages/research/ScientificCV";
import AddNewScientificCV from "./pages/research/AddNewScientificCV";
import EditScientificCV from "./pages/research/EditScientificCV";
import Standards from "./pages/management/Standards";
import AddNewStandard from "./pages/management/AddNewStandard";
import EditStandard from "./pages/management/EditStandard";
import Members from "./pages/management/Members";
import AddNewMember from "./pages/management/AddNewMember";
import EditMember from "./pages/management/EditMember";
import AddNewProject from "./pages/projects/AddNewProject";
import AddNewOrganization from "./pages/cooperation/AddNewOrganization";
import EditOrganization from "./pages/cooperation/EditOrganization";
import AddNewDelegation from "./pages/cooperation/AddNewDelegation";
import EditDelegation from "./pages/cooperation/EditDelegation";
import AddNewOutgoingDelegation from "./pages/cooperation/AddNewOutgoingDelegation";
import EditOutgoingDelegation from "./pages/cooperation/EditOutgoingDelegation";
import AddNewForeignStaff from "./pages/cooperation/AddNewForeignStaff";
import EditForeignStaff from "./pages/cooperation/EditForeignStaff";
import AddNewConference from "./pages/cooperation/AddNewConference";
import EditConference from "./pages/cooperation/EditConference";
import AddNewExpert from "./pages/management/AddNewExpert";
import PersonnelSummary from "./pages/management/PersonnelSummary";
import ResearchPositionSummary from "./pages/management/ResearchPositionSummary";
import EquipmentManagement from "./pages/management/EquipmentManagement";
import AddNewEquipment from "./pages/management/AddNewEquipment";
import EditEquipment from "./pages/management/EditEquipment";
import Awards from "./pages/management/Awards";
import AddNewAward from "./pages/management/AddNewAward";
import EditAward from "./pages/management/EditAward";
import ProjectDetail from "./pages/projects/ProjectDetail";
import AddProjectMember from "./pages/projects/AddProjectMember";
import AddNewFunding from "./pages/projects/AddNewFunding";
import AddProgressReport from "./pages/projects/AddProgressReport";
import EditProject from "./pages/projects/EditProject";
import SelectEvaluationCouncil from "./pages/projects/SelectEvaluationCouncil";
import SelectAcceptanceCouncil from "./pages/projects/SelectAcceptanceCouncil";
import SelectFundingCouncil from "./pages/projects/SelectFundingCouncil";
import SignImplementationContract from "./pages/projects/SignImplementationContract";
import TransferResponsible from "./pages/projects/TransferResponsible";
import Login from "./pages/auth/Login";
import Profile from "./pages/profile/Profile";
import ChangePassword from "./pages/profile/ChangePassword";
import { appRoutes } from "./routes";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-new-project"
            element={
              <ProtectedRoute>
                <AddNewProject />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-new-organization"
            element={
              <ProtectedRoute>
                <AddNewOrganization />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-organization/:id"
            element={
              <ProtectedRoute>
                <EditOrganization />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-new-delegation"
            element={
              <ProtectedRoute>
                <AddNewDelegation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-delegation/:id"
            element={
              <ProtectedRoute>
                <EditDelegation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-new-outgoing-delegation"
            element={
              <ProtectedRoute>
                <AddNewOutgoingDelegation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-outgoing-delegation/:id"
            element={
              <ProtectedRoute>
                <EditOutgoingDelegation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-new-foreign-staff"
            element={
              <ProtectedRoute>
                <AddNewForeignStaff />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-foreign-staff/:id"
            element={
              <ProtectedRoute>
                <EditForeignStaff />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-new-conference"
            element={
              <ProtectedRoute>
                <AddNewConference />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-conference/:id"
            element={
              <ProtectedRoute>
                <EditConference />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-new-contract"
            element={
              <ProtectedRoute>
                <AddNewContract />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contracts/edit/:id"
            element={
              <ProtectedRoute>
                <EditContract />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-new-council"
            element={
              <ProtectedRoute>
                <AddNewCouncil />
              </ProtectedRoute>
            }
          />
          <Route
            path="/councils/edit/:id"
            element={
              <ProtectedRoute>
                <EditCouncil />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-new-expert"
            element={
              <ProtectedRoute>
                <AddNewExpert />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-expert/:id"
            element={
              <ProtectedRoute>
                <EditExpert />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-new-scientific-cv"
            element={
              <ProtectedRoute>
                <AddNewScientificCV />
              </ProtectedRoute>
            }
          />
          <Route
            path="/scientific-cv/edit/:id"
            element={
              <ProtectedRoute>
                <EditScientificCV />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-new-standard"
            element={
              <ProtectedRoute>
                <AddNewStandard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-standard/:id"
            element={
              <ProtectedRoute>
                <EditStandard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-new-member"
            element={
              <ProtectedRoute>
                <AddNewMember />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-member/:id"
            element={
              <ProtectedRoute>
                <EditMember />
              </ProtectedRoute>
            }
          />
          <Route
            path="/personnel-summary"
            element={
              <ProtectedRoute>
                <PersonnelSummary />
              </ProtectedRoute>
            }
          />
          <Route
            path="/research-position-summary"
            element={
              <ProtectedRoute>
                <ResearchPositionSummary />
              </ProtectedRoute>
            }
          />
          <Route
            path="/equipment"
            element={
              <ProtectedRoute>
                <EquipmentManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-new-equipment"
            element={
              <ProtectedRoute>
                <AddNewEquipment />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-equipment/:id"
            element={
              <ProtectedRoute>
                <EditEquipment />
              </ProtectedRoute>
            }
          />
          <Route
            path="/awards"
            element={
              <ProtectedRoute>
                <Awards />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-new-award"
            element={
              <ProtectedRoute>
                <AddNewAward />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-award/:id"
            element={
              <ProtectedRoute>
                <EditAward />
              </ProtectedRoute>
            }
          />
          <Route
            path="/topics/approval"
            element={
              <ProtectedRoute>
                <TopicApproval />
              </ProtectedRoute>
            }
          />
          <Route
            path="/topics/approval/detail/:id"
            element={
              <ProtectedRoute>
                <ProjectDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/topics/approval/detail/:id/edit"
            element={
              <ProtectedRoute>
                <EditProject />
              </ProtectedRoute>
            }
          />
          <Route
            path="/topics/approval/detail/:id/council/select"
            element={
              <ProtectedRoute>
                <SelectEvaluationCouncil />
              </ProtectedRoute>
            }
          />
          <Route
            path="/topics/approval/detail/:id/council/acceptance"
            element={
              <ProtectedRoute>
                <SelectAcceptanceCouncil />
              </ProtectedRoute>
            }
          />
          <Route
            path="/topics/approval/detail/:id/council/funding"
            element={
              <ProtectedRoute>
                <SelectFundingCouncil />
              </ProtectedRoute>
            }
          />
          <Route
            path="/topics/approval/detail/:id/contract/sign"
            element={
              <ProtectedRoute>
                <SignImplementationContract />
              </ProtectedRoute>
            }
          />
          <Route
            path="/topics/approval/detail/:id/transfer"
            element={
              <ProtectedRoute>
                <TransferResponsible />
              </ProtectedRoute>
            }
          />
          <Route
            path="/topics/approval/detail/:id/members/add"
            element={
              <ProtectedRoute>
                <AddProjectMember />
              </ProtectedRoute>
            }
          />
          <Route
            path="/topics/approval/detail/:id/funding/add"
            element={
              <ProtectedRoute>
                <AddNewFunding />
              </ProtectedRoute>
            }
          />
          <Route
            path="/topics/approval/detail/:id/progress/add"
            element={
              <ProtectedRoute>
                <AddProgressReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/topics/ongoing"
            element={
              <ProtectedRoute>
                <OngoingProjects />
              </ProtectedRoute>
            }
          />
          <Route
            path="/topics/completed"
            element={
              <ProtectedRoute>
                <CompletedProjects />
              </ProtectedRoute>
            }
          />
          <Route
            path="/topics/incomplete"
            element={
              <ProtectedRoute>
                <IncompleteProjects />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cooperation/organizations"
            element={
              <ProtectedRoute>
                <CooperationOrganizations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cooperation/inbound"
            element={
              <ProtectedRoute>
                <IncomingDelegations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cooperation/delegation-detail/:id"
            element={
              <ProtectedRoute>
                <DelegationDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cooperation/outbound"
            element={
              <ProtectedRoute>
                <OutgoingDelegations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cooperation/outgoing-delegation-detail/:id"
            element={
              <ProtectedRoute>
                <OutgoingDelegationDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cooperation/delegation/add-member"
            element={
              <ProtectedRoute>
                <AddDelegationMember />
              </ProtectedRoute>
            }
          />
          <Route
            path="/management/council/add-member"
            element={
              <ProtectedRoute>
                <AddCouncilMember />
              </ProtectedRoute>
            }
          />
          <Route
            path="/management/council/members"
            element={
              <ProtectedRoute>
                <CouncilMembers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cooperation/foreign-staff"
            element={
              <ProtectedRoute>
                <ForeignStaff />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cooperation/conferences"
            element={
              <ProtectedRoute>
                <ConferencesWorkshops />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents/incoming"
            element={
              <ProtectedRoute>
                <IncomingDocuments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents/incoming-list"
            element={
              <ProtectedRoute>
                <IncomingDocumentsList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-new-document"
            element={
              <ProtectedRoute>
                <AddNewDocument />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents/incoming-unprocessed"
            element={
              <ProtectedRoute>
                <IncomingDocumentsUnprocessed />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents/incoming/pending"
            element={
              <ProtectedRoute>
                <IncomingDocumentsUnprocessed />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents/incoming-assigned"
            element={
              <ProtectedRoute>
                <IncomingDocumentsAssigned />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents/incoming-reading"
            element={
              <ProtectedRoute>
                <IncomingDocumentsReading />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents/incoming/reading"
            element={
              <ProtectedRoute>
                <IncomingDocumentsReading />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents/regulations"
            element={
              <ProtectedRoute>
                <LegalDocuments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents/groups"
            element={
              <ProtectedRoute>
                <DocumentGroups />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-new-document-group"
            element={
              <ProtectedRoute>
                <AddNewDocumentGroup />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents/outgoing/pending"
            element={
              <ProtectedRoute>
                <OutgoingDocumentsUnprocessed />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents/outgoing/assigned"
            element={
              <ProtectedRoute>
                <OutgoingDocumentsAssigned />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents/outgoing/reading"
            element={
              <ProtectedRoute>
                <OutgoingDocumentsReading />
              </ProtectedRoute>
            }
          />
          <Route
            path="/articles"
            element={
              <ProtectedRoute>
                <ScientificArticles />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-new-article"
            element={
              <ProtectedRoute>
                <AddNewArticle />
              </ProtectedRoute>
            }
          />
          <Route
            path="/articles/detail/:id"
            element={
              <ProtectedRoute>
                <ArticleDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/articles/edit/:id"
            element={
              <ProtectedRoute>
                <EditArticle />
              </ProtectedRoute>
            }
          />
          <Route
            path="/initiatives"
            element={
              <ProtectedRoute>
                <ExperienceInitiatives />
              </ProtectedRoute>
            }
          />
          <Route
            path="/initiatives/detail/:id"
            element={
              <ProtectedRoute>
                <ExperienceInitiativeDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-new-initiative"
            element={
              <ProtectedRoute>
                <AddNewInitiative />
              </ProtectedRoute>
            }
          />
          <Route
            path="/initiatives/edit/:id"
            element={
              <ProtectedRoute>
                <EditInitiative />
              </ProtectedRoute>
            }
          />
          <Route
            path="/intellectual"
            element={
              <ProtectedRoute>
                <IntellectualProperty />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-new-intellectual-property"
            element={
              <ProtectedRoute>
                <AddNewIntellectualProperty />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contracts"
            element={
              <ProtectedRoute>
                <Contracts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contracts/detail/:id"
            element={
              <ProtectedRoute>
                <ContractDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/councils"
            element={
              <ProtectedRoute>
                <Councils />
              </ProtectedRoute>
            }
          />
          <Route
            path="/councils/detail/:id"
            element={
              <ProtectedRoute>
                <CouncilDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/experts"
            element={
              <ProtectedRoute>
                <Experts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/scientific-cv"
            element={
              <ProtectedRoute>
                <ScientificCV />
              </ProtectedRoute>
            }
          />
          <Route
            path="/standards"
            element={
              <ProtectedRoute>
                <Standards />
              </ProtectedRoute>
            }
          />
          <Route
            path="/members"
            element={
              <ProtectedRoute>
                <Members />
              </ProtectedRoute>
            }
          />
          {appRoutes
            .filter(
              (route) =>
                route.path !== "/add-new-project" &&
                route.path !== "/add-new-organization" &&
                route.path !== "/add-new-delegation" &&
                route.path !== "/add-new-outgoing-delegation" &&
                route.path !== "/add-new-foreign-staff" &&
                route.path !== "/add-new-conference" &&
                route.path !== "/add-new-contract" &&
                route.path !== "/add-new-council" &&
                route.path !== "/add-new-expert" &&
                route.path !== "/add-new-scientific-cv" &&
                route.path !== "/add-new-standard" &&
                route.path !== "/add-new-member" &&
                route.path !== "/personnel-summary" &&
                route.path !== "/research-position-summary" &&
                route.path !== "/equipment" &&
                route.path !== "/add-new-equipment" &&
                route.path !== "/awards" &&
                route.path !== "/add-new-award" &&
                route.path !== "/cooperation/organizations" &&
                route.path !== "/cooperation/inbound" &&
                route.path !== "/cooperation/outbound" &&
                route.path !== "/cooperation/foreign-staff" &&
                route.path !== "/cooperation/conferences" &&
                route.path !== "/documents/incoming" &&
                route.path !== "/documents/incoming-unprocessed" &&
                route.path !== "/documents/incoming/pending" &&
                route.path !== "/documents/incoming-assigned" &&
                route.path !== "/documents/incoming-reading" &&
                route.path !== "/documents/incoming/reading" &&
                route.path !== "/documents/outgoing" &&
                route.path !== "/documents/outgoing/pending" &&
                route.path !== "/documents/outgoing/assigned" &&
                route.path !== "/documents/outgoing/reading" &&
                route.path !== "/articles" &&
                route.path !== "/initiatives" &&
                route.path !== "/intellectual" &&
                route.path !== "/contracts" &&
                route.path !== "/councils" &&
                route.path !== "/experts" &&
                route.path !== "/scientific-cv" &&
                route.path !== "/standards" &&
                route.path !== "/members"
            ) // Exclude add-new-project and cooperation routes since they're handled separately
            .map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <ProtectedRoute>
                    <GenericPage title={route.title} />
                  </ProtectedRoute>
                }
              />
            ))}
          <Route
            path="/statistics/overview"
            element={
              <ProtectedRoute>
                <OverviewStatistics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/statistics/progress"
            element={
              <ProtectedRoute>
                <ProgressReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ongoing-projects/detail/:id"
            element={
              <ProtectedRoute>
                <OngoingProjectDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/completed-projects/detail/:id"
            element={
              <ProtectedRoute>
                <CompletedProjectDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/completed-projects/detail/:id/products/type1/add"
            element={
              <ProtectedRoute>
                <AddProductTypeI />
              </ProtectedRoute>
            }
          />
          <Route
            path="/completed-projects/detail/:id/products/type2/add"
            element={
              <ProtectedRoute>
                <AddProductTypeII />
              </ProtectedRoute>
            }
          />
          <Route
            path="/completed-projects/detail/:id/products/type3/add"
            element={
              <ProtectedRoute>
                <AddProductTypeIII />
              </ProtectedRoute>
            }
          />
          <Route
            path="/completed-projects/detail/:id/products/type3/journal/add"
            element={
              <ProtectedRoute>
                <AddProductTypeIIIJournal />
              </ProtectedRoute>
            }
          />
          <Route
            path="/completed-projects/detail/:id/products/type3/book/add"
            element={
              <ProtectedRoute>
                <AddProductTypeIIIBook />
              </ProtectedRoute>
            }
          />
          <Route
            path="/completed-projects/edit/:id"
            element={
              <ProtectedRoute>
                <EditCompletedProject />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ongoing-projects/edit/:id"
            element={
              <ProtectedRoute>
                <EditOngoingProject />
              </ProtectedRoute>
            }
          />
          <Route
            path="/statistics/implementation"
            element={
              <ProtectedRoute>
                <ProjectImplementation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/statistics/projects"
            element={
              <ProtectedRoute>
                <ProjectStatistics />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
